module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v("O tamanho dos arquivos pode impactar diretamente na performance e tempo de carregamento do aplicativo.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.id_pais.$error
    }
  }, [_c('label', [_vm._v("País*")]), _vm._v(" "), _c('select-api', {
    attrs: {
      "endpoint": '/pais/pesquisa',
      "opt-text": 'nome',
      "select-option": true
    },
    model: {
      value: (_vm.model.id_pais),
      callback: function($$v) {
        _vm.$set(_vm.model, "id_pais", $$v)
      },
      expression: "model.id_pais"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.nome.$error
    }
  }, [_c('label', [_vm._v("Nome*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.nome),
      expression: "model.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "150"
    },
    domProps: {
      "value": (_vm.model.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('file-image', {
    attrs: {
      "label": 'Arquivo',
      "accept": 'application/pdf',
      "arquivo": _vm.model.arquivo
    },
    model: {
      value: (_vm.imagem),
      callback: function($$v) {
        _vm.imagem = $$v
      },
      expression: "imagem"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-manual'
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fas fa-menu"
  }), _vm._v(" Manual Usuário\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Atenção!")]), _vm._v("\n                            O tamanho máximo e indicado para o\n                            "), _c('strong', [_vm._v("Arquivo")]), _vm._v(" é de\n                            "), _c('strong', [_vm._v("300kb")]), _vm._v(".\n                        ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-167f2fe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/manual/Form.vue
// module id = 834
// module chunks = 1